module.exports = __webpack_public_path__ + "images/bdadbed6f5883ec78320896c1dacd45f-nowifi-item.svg";